import { PATHS } from '../../routing-system/appPaths';
import { SIGNUP_CHECKPOINT } from './signupEnums';
import { SignupStepper } from './signupInterfaces';

export const FIRST_COUNTRY_INDEX = 0;
export const RESEND_AVAILABLE_AFTER_SECONDS = 60;
export const VERIFICATION_CODE_LENGTH = 4;
export const CAN_SEND_NEW_VERIFICATION_CODE_AFTER_SECONDS = 15;
export const CAN_LOOKUP_ADDRESS_POSTCODE_AFTER_SECONDS = 10;

export const ukSignUpSteps: SignupStepper[] = [
  { path: PATHS.SIGNUP.STEPS.EMAIL, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.PASSWORD, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.OFFERS_AND_REWARDS, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.TERMS_AND_CONDITIONS, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.INFO, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.ADDRESS, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.PHONE, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.UNVERIFIED, performInBackground: false, performRegistrationFinishedTracking: true },
  { path: PATHS.SIGNUP.STEPS.DEPOSIT_LIMIT, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.DEPOSIT, performInBackground: false, performRegistrationFinishedTracking: false },
];

export const betkwiffSignUpSteps: SignupStepper[] = [
  { path: PATHS.SIGNUP.STEPS.EMAIL, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.PASSWORD, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.OFFERS_AND_REWARDS, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.TERMS_AND_CONDITIONS, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.INFO, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.ADDRESS, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.PHONE, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.OPT_IN_REWARDS, performInBackground: false, performRegistrationFinishedTracking: true },
  { path: PATHS.SIGNUP.STEPS.DEPOSIT_LIMIT, performInBackground: true, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.DEPOSIT, performInBackground: false, performRegistrationFinishedTracking: false },
];

export const keSignUpSteps: SignupStepper[] = [
  { path: PATHS.SIGNUP.STEPS.PHONE, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.PASSWORD, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.OFFERS_AND_REWARDS, performInBackground: true, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.TERMS_AND_CONDITIONS, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.INFO, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.ADDRESS, performInBackground: false, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.UNVERIFIED, performInBackground: true, performRegistrationFinishedTracking: true },
  { path: PATHS.SIGNUP.STEPS.DEPOSIT_LIMIT, performInBackground: true, performRegistrationFinishedTracking: false },
  { path: PATHS.SIGNUP.STEPS.DEPOSIT, performInBackground: false, performRegistrationFinishedTracking: false },
];

export const STARTER_CHECKPOINTS = [SIGNUP_CHECKPOINT.AFRICA_CREDS, SIGNUP_CHECKPOINT.IOM_CREDS, SIGNUP_CHECKPOINT.UK_CREDS];
